import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Intro from "./sections/Intro";
import Join from "./sections/Join";
import Company from "./sections/Company";
import Request from "./sections/Request";
import Event from "./sections/Event";
import Partner from "./sections/Partner";
import Head from "../Base/Head";

export default function DEAL({ event }) {
  const head = {
    title: "DEAL - Landmark Executive Roundtable Series - Landmark Ventures",
    description:
      "In a landscape defined by constant disruption, DEAL – Dialogue on Exits, Acquisitions & Landscape – offers a rare forum for unfiltered conversation and strategic connection. Curated and hosted by Landmark Ventures’ Investment Banking team, this off-the-record series is designed to illuminate what’s next: from emerging market signals to transformative deal opportunities.",
    url: "https://deal.landmarkventures.com",
    image: "https://i.imgur.com/T07eG6R.jpeg",
  };

  return (
    <>
      <Head head={head} />
      <div className="events-wrapper deal-wrapper redesign">
        <Intro event={event} />
        {/* <Join /> */}
        {/* <Event /> */}
        <Request event={event} />
        {/* <Company /> */}
        {/* <Partner /> */}
      </div>
    </>
  );
}
